
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { VSnackbar, VBtn, VIcon } from 'vuetify/lib';

Vue.use(Vuetify);

const ToastPlugin = {
  install(Vue) {
    Vue.prototype.$toast = {
      show({ message, timeout = 10000, color }) {
        const ToastComponent = Vue.extend({
          vuetify: new Vuetify(),
          data() {
            return {
              snackbar: true,
            };
          },
          render(h) {
            return h(VSnackbar, {
              props: {
                value: this.snackbar,
                timeout,
                bottom: true,
                color,
              },
              scopedSlots: {
                default: () => message,
                action: () =>
                  h(VBtn, {
                    props: {
                      icon: true,
                    },
                    on: {
                      click: () => {
                        this.snackbar = false;
                      },
                    },
                  }, [
                    h(VIcon, 'mdi-close'), 
                  ]),
              },
            });
          },
        });

        const component = new ToastComponent();
        component.$mount();
        document.body.appendChild(component.$el);

        setTimeout(() => {
          document.body.removeChild(component.$el);
          component.$destroy();
        }, timeout);
      },
      success(message, timeout = 10000) {
        this.show({ message, timeout, color: '#4CAF50' });
      },
      error(message, timeout = 10000) {
        this.show({ message, timeout, color: '#F44336' });
      },
      info(message, timeout = 10000) {
        this.show({ message, timeout, color: '#2196F3' });
      },
      warning(message, timeout = 10000) {
        this.show({ message, timeout, color: '#FFC107' });
      },
    };
  },
};

Vue.use(ToastPlugin);





